import {useCallback, useMemo, useState} from 'react'
import {requestData} from 'services'
import {useHistory} from 'utils/routes'

export function useTransactionDetailCancel(payment_invoice: string) {
  const history = useHistory()

  const stateCancelModal = useState(false)
  const handleCancelTransaction = useCallback(() => {
    requestData('giftshop_cancel_transaction', {
      actionType: 'execute',
      useDefaultMessage: true,
      data: {payment_invoice},
      onRequestSuccess: ({status: reqStatus}) => {
        reqStatus === 200 && history.replace('giftshop_balance', {})
      },
    })
  }, [history, payment_invoice])

  return useMemo(
    () => ({
      stateCancelModal,
      handleCancelTransaction,
    }),
    [handleCancelTransaction, stateCancelModal],
  )
}
